import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './_images/3-0-0.png'
import _imports_1 from './_images/4-0-0.png'
import _imports_2 from './_images/5-0-0.png'
import _imports_3 from './_images/6-0-0.png'
import _imports_4 from './_images/6-0-1.png'
import _imports_5 from './_images/6-0-2.png'
import _imports_6 from './_images/6-0-3.png'
import _imports_7 from './_images/7-0-0.png'
import _imports_8 from './_images/7-0-1.png'
import _imports_9 from './_images/7-0-2.png'
import _imports_10 from './_images/8-0-0.png'
import _imports_11 from './_images/9-0-0.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-1f51bf10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrapper" }
const _hoisted_2 = { style: {"text-align":"center"} }
const _hoisted_3 = { class: "item-wrapper" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  class: "bold-desc",
  style: {"font-weight":"400"}
}
const _hoisted_6 = { class: "item-wrapper" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "item-wrapper" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "bold-desc" }
const _hoisted_11 = { class: "bold-desc" }
const _hoisted_12 = {
  class: "bold-desc",
  style: {"font-weight":"400"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = {
  class: "bold-desc",
  style: {"font-weight":"400"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { class: "desc" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img-blk"
  })
], -1))
const _hoisted_19 = { class: "item-wrapper" }
const _hoisted_20 = { class: "title" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "img-blk",
    width: "700"
  })
], -1))
const _hoisted_22 = { class: "item-wrapper" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "img-blk"
  })
], -1))
const _hoisted_25 = { class: "item-wrapper" }
const _hoisted_26 = { class: "title" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "img-blk"
  })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    class: "img-blk"
  })
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "img-blk"
  })
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    class: "img-blk"
  })
], -1))
const _hoisted_31 = { class: "item-wrapper" }
const _hoisted_32 = { class: "title" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    class: "img-blk"
  })
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    class: "img-blk",
    width: "700"
  })
], -1))
const _hoisted_35 = { class: "step7-hint" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    class: "img-blk"
  })
], -1))
const _hoisted_40 = { class: "item-wrapper" }
const _hoisted_41 = { class: "title" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_10,
    class: "img-blk"
  })
], -1))
const _hoisted_43 = { class: "item-wrapper" }
const _hoisted_44 = { class: "title" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_11,
    class: "img-blk"
  })
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.t('domainDeploymentHelp.pageTitle')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('domainDeploymentHelp.step1Title')), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('domainDeploymentHelp.step1Note')), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t('domainDeploymentHelp.step2Title')), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t('domainDeploymentHelp.step3Title')), 1),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('domainDeploymentHelp.step3Intro')), 1),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createTextVNode(_toDisplayString(_ctx.t('domainDeploymentHelp.step3Case1Intro')) + " ", 1),
          _hoisted_13,
          _createTextVNode(_toDisplayString(_ctx.t('domainDeploymentHelp.step3Case1Example')), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createTextVNode(_toDisplayString(_ctx.t('domainDeploymentHelp.step3Case2Intro')) + " ", 1),
          _hoisted_15,
          _createTextVNode(_toDisplayString(_ctx.t('domainDeploymentHelp.step3Case2Line1')) + " ", 1),
          _hoisted_16,
          _createTextVNode(_toDisplayString(_ctx.t('domainDeploymentHelp.step3Case2Example')), 1)
        ]),
        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.t('domainDeploymentHelp.step3Footnote')), 1),
        _hoisted_18
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t('domainDeploymentHelp.step4Title')), 1),
      _hoisted_21
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.t('domainDeploymentHelp.step5Title')), 1),
      _hoisted_24
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.t('domainDeploymentHelp.step6Title')), 1),
      _hoisted_27,
      _hoisted_28,
      _hoisted_29,
      _hoisted_30
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.t('domainDeploymentHelp.step7Title')), 1),
      _hoisted_33,
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _createTextVNode(" " + _toDisplayString(_ctx.t('domainDeploymentHelp.step7AdminHint')) + " ", 1),
        _hoisted_37,
        _hoisted_38
      ]),
      _hoisted_39
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.t('domainDeploymentHelp.step8Title')), 1),
      _hoisted_42
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.t('domainDeploymentHelp.step9Title')), 1),
      _hoisted_45
    ]),
    _hoisted_46,
    _hoisted_47
  ]))
}